import React, { useRef } from 'react';
import './ReportRegions.css';

// Import icons and the new map images
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import indiaMap from '../../assets/images/region-india.png';
import argentinaMap from '../../assets/images/region-argentina.png';
import australiaMap from '../../assets/images/region-australia.png';


const regionsData = [
  { name: 'India', image: indiaMap },
  { name: 'Argentina', image: argentinaMap },
  { name: 'Australia', image: australiaMap },
];

const ReportRegions = () => {
  const scrollContainerRef = useRef(null);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      scrollContainerRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section className="report-regions-section">
      <div className="report-regions-container">
        <div className="section-header">
          <h2>What's happening in different regions</h2>
          <div className="header-line"></div>
        </div>
        <p className="section-subtitle">
          CRISHI gives you region-wise market updates, so you're never out of touch with the global picture.
        </p>

        <div className="report-regions-carousel-container">
          <button className="scroll-arrow left" onClick={() => scroll('left')}><FiArrowLeft /></button>
          <div className="report-regions-scroller" ref={scrollContainerRef}>
            {regionsData.map((region, index) => (
              <div key={index} className="report-region-card">
                <div className="report-region-card-image">
                  <img src={region.image} alt={`Map of ${region.name}`} />
                </div>
                <p className="report-region-card-name">{region.name}</p>
              </div>
            ))}
          </div>
          <button className="scroll-arrow right" onClick={() => scroll('right')}><FiArrowRight /></button>
        </div>
      </div>
    </section>
  );
};

export default ReportRegions;